import React from "react";
import { useState, useEffect } from "react";
import clear from "../../images/weather/clear.png";
import clouds from "../../images/weather/clouds.png";
import drizzle from "../../images/weather/drizzle.png";
import mist from "../../images/weather/mist.png";
import rain from "../../images/weather/rain.png";
import snow from "../../images/weather/snow.png";
import wind from "../../images/weather/wind.png";

const WeatherUb = () => {
  const [weather, setWeather] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchWeather = async () => {
      const apiKey = "10e99030465a62b40d2a7890afc6901a";
      const city = "ulaanbaatar";
      const url = `https://api.openweathermap.org/data/2.5/weather?q=${city}&units=metric&appid=${apiKey}`;

      try {
        const res = await fetch(url);
        if (!res.ok)
          throw new Error(`Алдаа гарлаа: ${res.status} ${res.statusText}`);
        const data = await res.json();
        setWeather(data);
      } catch (err) {
        setError(err.message);
      }
    };

    fetchWeather();
  }, []);

  // timestamp → цаг болгон хөрвүүлэх функц
  const formatTime = (unix) => {
    return new Date(unix * 1000).toLocaleTimeString("mn-MN", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  //Тоймлох
  const formatTemp = (temp) => {
    const rounded = temp.toFixed(1);
    if (rounded.endsWith(".0")) {
      return parseInt(rounded, 10);
    }
    return rounded;
  };
  return (
    <>
      {error && <p style={{ color: "red", fontWeight: 600 }}>{error}</p>}
      {weather ? (
        <div className="weather">
          <div className="withimg">
            <span className="cityName">
              Улаанбаатарт: {formatTemp(weather.main.temp)}°C
            </span>
            <img
              src={
                weather.weather[0].main === "Clear"
                  ? clear
                  : weather.weather[0].main === "Clouds"
                    ? clouds
                    : weather.weather[0].main === "Rain"
                      ? rain
                      : weather.weather[0].main === "Snow"
                        ? snow
                        : weather.weather[0].main === "Drizzle"
                          ? drizzle
                          : weather.weather[0].main === "Mist"
                            ? mist
                            : wind
              }
              style={{
                width: "30px",
                height: "30px",
                padding: 0,
                backgroundColor: "#e68000",
                borderRadius: "50%",
              }}
              alt="weather"
            />
          </div>
          <span className="temperature">
            Нар жаргах: {formatTime(weather.sys.sunset)}
          </span>
        </div>
      ) : (
        <p>Уншиж байна...</p>
      )}
    </>
  );
};

export default WeatherUb;
